import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'adf-expander',
	standalone: true,
	imports: [CommonModule, NgbTooltip, TranslateModule],
	templateUrl: './expander.component.html',
	styleUrl: './expander.component.scss',
})
export class ExpanderComponent {
	document = inject(DOCUMENT) as any;

	onToggle() {
		if (!this.document.fullscreenElement) {
			this.onExpand();
		} else {
			this.onCollapse();
		}
	}

	onExpand() {
		if (this.document.documentElement.requestFullscreen) {
			this.document.documentElement.requestFullscreen();
		} else if (this.document.documentElement.webkitRequestFullscreen) {
			/* Safari */
			this.document.documentElement.webkitRequestFullscreen();
		} else if (this.document.documentElement.msRequestFullscreen) {
			/* IE11 */
			this.document.documentElement.msRequestFullscreen();
		}
	}

	onCollapse() {
		if (this.document.exitFullscreen) {
			this.document.exitFullscreen();
		} else if (this.document.webkitExitFullscreen) {
			/* Safari */
			this.document.webkitExitFullscreen();
		} else if (this.document.msExitFullscreen) {
			/* IE11 */
			this.document.msExitFullscreen();
		}
	}
}
